import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { mapStorySentenceAnimationSequence } from '../mappers/story-sentence-animation-sequence.mapper.ts';
import { BallAnimation } from '../slices/ball/ball.slice.types.ts';

import { selectAnimationPositions } from './story-sentence-ball-animation-positions.selector.ts';
import { selectAnimationPrerequisites } from './story-sentence-ball-animation-prerequisites.selector.ts';

export const selectStorySentenceBallAnimationSequence = createMemoizedSelector(
  [selectAnimationPrerequisites, selectAnimationPositions],
  (prerequisites, animationPositions): BallAnimation[] => {
    if (!animationPositions) {
      return [];
    }

    return mapStorySentenceAnimationSequence({
      animationPositions,
      appState: prerequisites.appState,
      lines: prerequisites.currentStory!.lines,
    });
  }
);
